import styled, { css } from 'styled-components'
import type { Props } from './types'

export const RemoveButton = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  top: var(--space-100);
  right: var(--space-100);

  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  border-radius: var(--radius-brand);

  background: var(--bg-primary);
  visibility: hidden;

  color: var(--text-primary);
`

export const Container = styled.div<{
  $disabled: Props['disabled']
  $appearance: Props['appearance']
}>`
  position: relative;
  height: 100%;
  overflow: hidden;
  background: var(--bg-transparent);
  border-radius: var(--radius-brand);

  ${({ $appearance }) =>
    $appearance === 'dark' &&
    css`
      background: var(--text-primary);
    `}

  cursor: pointer;

  &:hover {
    ${RemoveButton} {
      visibility: visible;
    }
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
    `}
`

export const Image = styled.img`
  position: relative;

  width: 100%;
  height: 100%;

  object-fit: contain;
`

export const Video = styled.video`
  position: relative;

  width: 100%;
  height: 100%;

  object-fit: contain;
`
